// Markaziy metod ma'lumotlar bazasi — radar chart, tavsiyachi va dars rejasi uchun
// Mezonlar 1-10 ball: vaqt (qancha kam vaqt talab qilsa shuncha yuqori), samaradorlik,
// faollik (o'quvchi faolligi), soddalik (qo'llash osonligi), resurs (kam resurs = yuqori), baholash imkoniyati

export const methods = [
    {
        id: "3I",
        name: "3I metodi",
        path: "/method/3I",
        short: "Individualizatsiya, Interaksiya, Integratsiya",
        metrics: { vaqt: 6, samaradorlik: 9, faollik: 9, soddalik: 6, resurs: 7, baholash: 8 },
        // Tavsiyachi uchun: qaysi maqsadlarga mos
        goals: ["ijodkorlik", "hamkorlik", "amaliyot"],
        subjects: ["pedagogika", "psixologiya", "metodika", "tarbiya"],
        grade: ["o'rta", "yuqori"],
        time: ["o'rta", "uzoq"],
    },
    {
        id: "CLIL",
        name: "CLIL metodi",
        path: "/method/CLIL",
        short: "Fan va til integratsiyasi",
        metrics: { vaqt: 5, samaradorlik: 8, faollik: 8, soddalik: 5, resurs: 6, baholash: 7 },
        goals: ["til", "amaliyot", "tahlil"],
        subjects: ["ingliz tili", "fan", "tabiiy fan", "tarix"],
        grade: ["o'rta", "yuqori"],
        time: ["uzoq"],
    },
    {
        id: "SQ3R",
        name: "SQ3R metodi",
        path: "/method/SQ3R",
        short: "Matn bilan ishlash: Survey-Question-Read-Recite-Review",
        metrics: { vaqt: 8, samaradorlik: 8, faollik: 7, soddalik: 9, resurs: 10, baholash: 7 },
        goals: ["yodlash", "tahlil", "o'qish"],
        subjects: ["adabiyot", "tarix", "ona tili", "matn"],
        grade: ["boshlang'ich", "o'rta", "yuqori"],
        time: ["qisqa", "o'rta"],
    },
    {
        id: "GRASPS",
        name: "GRASPS metodi",
        path: "/method/GRASPS",
        short: "Muammoli vaziyatga yo'naltirilgan model",
        metrics: { vaqt: 4, samaradorlik: 9, faollik: 10, soddalik: 5, resurs: 6, baholash: 9 },
        goals: ["ijodkorlik", "amaliyot", "muammo_yechish"],
        subjects: ["pedagogika", "metodika", "loyiha", "ijtimoiy fan"],
        grade: ["o'rta", "yuqori"],
        time: ["uzoq"],
    },
    {
        id: "SMART",
        name: "SMART metodi",
        path: "/method/SMART",
        short: "Maqsadlarni aniq belgilash",
        metrics: { vaqt: 9, samaradorlik: 7, faollik: 6, soddalik: 9, resurs: 10, baholash: 9 },
        goals: ["rejalashtirish", "baholash"],
        subjects: ["pedagogika", "metodika", "boshqaruv", "loyiha"],
        grade: ["o'rta", "yuqori"],
        time: ["qisqa"],
    },
    {
        id: "WHERETO",
        name: "WHERETO metodi",
        path: "/method/WHERETO",
        short: "Mashg'ulotni samarali rejalashtirish",
        metrics: { vaqt: 6, samaradorlik: 8, faollik: 8, soddalik: 6, resurs: 7, baholash: 9 },
        goals: ["rejalashtirish", "amaliyot", "baholash"],
        subjects: ["pedagogika", "metodika", "tarbiya"],
        grade: ["o'rta", "yuqori"],
        time: ["o'rta", "uzoq"],
    },
    {
        id: "qosh_daraxt",
        name: "Qo'sh daraxt metodi",
        path: "/method/qosh_daraxt",
        short: "Grafik organayzer orqali bilimni tizimlashtirish",
        metrics: { vaqt: 7, samaradorlik: 8, faollik: 9, soddalik: 8, resurs: 9, baholash: 7 },
        goals: ["tahlil", "yodlash", "ijodkorlik"],
        subjects: ["adabiyot", "ona tili", "tarix", "tabiiy fan"],
        grade: ["boshlang'ich", "o'rta"],
        time: ["qisqa", "o'rta"],
    },
];

export const metricLabels = {
    vaqt: "Vaqt tejamkorligi",
    samaradorlik: "Samaradorlik",
    faollik: "O'quvchi faolligi",
    soddalik: "Qo'llash osonligi",
    resurs: "Resurs tejamkorligi",
    baholash: "Baholash imkoniyati",
};

// Tavsiyachi tizimi uchun ball berish funksiyasi
export function recommendMethods({ goal, subject, grade, time }) {
    return methods
        .map((m) => {
            let score = 0;
            if (goal && m.goals.includes(goal)) score += 40;
            if (subject && m.subjects.some((s) => s.toLowerCase().includes(subject.toLowerCase()))) score += 25;
            if (grade && m.grade.includes(grade)) score += 15;
            if (time && m.time.includes(time)) score += 20;
            // Bazaviy samaradorlik komponenti
            score += (m.metrics.samaradorlik + m.metrics.faollik) / 2;
            return { ...m, score: Math.round(score) };
        })
        .sort((a, b) => b.score - a.score);
}

// Davlat tajribalari uchun (xarita uchun)
export const experiments = [
    {
        id: "usa",
        name: "AQSH",
        path: "/experiment/usa",
        coords: [37.0902, -95.7129],
        flag: "/assets/images/usa2_flag.jpg",
        pisa: 478,
        teacherSalary: "$65,000",
        eduSpend: "5.4% YIM",
        highlight: "STEAM, Charter maktablari, layiha asoslangan ta'lim",
    },
    {
        id: "germany",
        name: "Germaniya",
        path: "/experiment/germany",
        coords: [51.1657, 10.4515],
        flag: "/assets/images/germany2_flag.jpg",
        pisa: 500,
        teacherSalary: "€70,000",
        eduSpend: "4.7% YIM",
        highlight: "Dual ta'lim tizimi, kasb-hunar ta'limining yuqori darajasi",
    },
    {
        id: "korea",
        name: "Janubiy Koreya",
        path: "/experiment/korea",
        coords: [35.9078, 127.7669],
        flag: "/assets/images/korea2_flag.jpg",
        pisa: 520,
        teacherSalary: "$55,000",
        eduSpend: "5.1% YIM",
        highlight: "Raqamli ta'lim, yuqori standartlar, hakathon va STEM",
    },
    {
        id: "russia",
        name: "Rossiya",
        path: "/experiment/russia",
        coords: [61.524, 105.3188],
        flag: "/assets/images/russia2_flag.jpg",
        pisa: 488,
        teacherSalary: "$15,000",
        eduSpend: "3.7% YIM",
        highlight: "Klassik akademik tayyorgarlik, fundamental fanlar kuchli",
    },
];
